import { Box, IconButton } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import React, { useState } from "react";
import ImportDataModal from "../../../../modals/yourAssets/BOA/ImportDataModal";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

const ImportData = (props) => {
  const { handleViewFile, handleRemoveFile } = props;
  const [dataModal, setDataModal] = useState(false);
  const { t } = useTranslation();
  const handleUploadButtonClick = () => {
    return props.documentList.length < 15
      ? setDataModal(true)
      : toast.error(t("uploaded-documents-limit-reached"));
  };
  return (
    <Box
      component="div"
      width="100%"
      display="flex"
      flexDirection="row-reverse"
    >
      <IconButton
        sx={{
          backgroundColor: "color.magentaLight2",
          borderRadius: "40px",
          padding: "8px 16px",
        }}
        onClick={() => {
          handleUploadButtonClick();
        }}
      >
        <FileUploadOutlinedIcon />
      </IconButton>
      <Box
        component="div"
        className="scroll-bar"
        sx={{
          overflowX: "scroll",
          display: "flex",
          flexDirection: "row-reverse",
          width: "100%",
        }}
      >
        {props.documentList?.map((elem) => {
          return (
            <Box
              component="div"
              position="relative"
              key={elem}
              sx={{
                cursor: "pointer",
                minHeight: "30px",
                minWidth: "30px",
              }}
            >
              <TaskOutlinedIcon
                fontSize="medium"
                sx={{
                  position: "absolute",
                  bottom: "0",
                  right: "10px",
                }}
                onClick={() => handleViewFile(elem)}
              />
              <CloseOutlinedIcon
                sx={{
                  position: "absolute",
                  left: "12px",
                  width: "12px",
                  bottom: "12px",
                }}
                onClick={() => handleRemoveFile(elem)}
              />
            </Box>
          );
        })}
      </Box>

      <ImportDataModal
        open={dataModal}
        handleClose={() => {
          setDataModal(false);
        }}
        sectionId={props.sectionId}
      />
    </Box>
  );
};

export default ImportData;
